import * as yup from 'yup';

import { ERROR_MESSAGES } from './error-messages';
import { REPORT_FILE_FORMAT } from './reports';

export const VALIDATION_SCHEMAS = {
  EDIT_CONTACT: isStateRequired =>
    yup.object().shape({
      company: yup
        .string()
        .trim()
        .max(400, ERROR_MESSAGES.MAX_LENGTH(400))
        .required(ERROR_MESSAGES.REQUIRED),
      contact: yup.string().trim().max(255, ERROR_MESSAGES.MAX_LENGTH(255)),
      title: yup.string().trim().max(255, ERROR_MESSAGES.MAX_LENGTH(255)),
      industry: yup.string().trim().max(40, ERROR_MESSAGES.MAX_LENGTH(40)),
      country: yup.string().required(ERROR_MESSAGES.REQUIRED),
      state: isStateRequired
        ? yup.string().required(ERROR_MESSAGES.REQUIRED)
        : yup.string(),
      city: yup.string().required(ERROR_MESSAGES.REQUIRED),
      address: yup.string().trim().max(255, ERROR_MESSAGES.MAX_LENGTH(255)),
      website: yup.string().trim().max(400, ERROR_MESSAGES.MAX_LENGTH(400)),
      email: yup
        .string()
        .trim()
        .max(255, ERROR_MESSAGES.MAX_LENGTH(255))
        .email(ERROR_MESSAGES.EMAIL_NOT_VALID),
      linkedin: yup.string().trim().max(255, ERROR_MESSAGES.MAX_LENGTH(255)),
      phoneNumbers: yup.array().of(
        yup.object().shape({
          value: yup
            .string()
            .required(ERROR_MESSAGES.REQUIRED)
            .matches(/^\+1 \d{3} \d{3} \d{4}$/, ERROR_MESSAGES.PHONE_NOT_VALID)
            .test({
              name: 'unique',
              message: ERROR_MESSAGES.PHONE_ALREADY_EXIST,
              test: function (fieldValue) {
                const phoneNumbers = this.from[1].value.phoneNumbers;
                const currentIndex = this.options.index;

                const firstIndex = phoneNumbers.findIndex(
                  ({ value }) => value === fieldValue,
                );

                if (firstIndex === currentIndex) return true;

                return this.createError({
                  path: this.path,
                  message: ERROR_MESSAGES.PHONE_ALREADY_EXIST,
                });
              },
            }),
          isBestPhoneNumber: yup.number().oneOf([0, 1]),
        }),
      ),
    }),
  CALL_NOTES: yup.object().shape({
    callNotes: yup.string().trim().max(500, ERROR_MESSAGES.MAX_LENGTH(500)),
  }),
  LOGIN: yup.object().shape({
    username: yup.string().trim().required(ERROR_MESSAGES.REQUIRED),
    password: yup.string().trim().required(ERROR_MESSAGES.REQUIRED),
  }),
  LOGIN_TIME_ZONE: isStateRequired =>
    yup.object().shape({
      country: yup.string().required(ERROR_MESSAGES.REQUIRED),
      state: isStateRequired
        ? yup.string().required(ERROR_MESSAGES.REQUIRED)
        : yup.string(),
      city: yup.string().required(ERROR_MESSAGES.REQUIRED),
    }),
  FORGOT_PASSWORD: yup.object().shape({
    email: yup.string().trim().required(ERROR_MESSAGES.REQUIRED),
  }),
  SCRIPT: yup.object().shape({
    ScriptName: yup
      .string()
      .trim()
      .max(255, ERROR_MESSAGES.MAX_LENGTH(255))
      .required(ERROR_MESSAGES.REQUIRED),
    ScriptDescription: yup
      .string()
      .trim()
      .max(1000, ERROR_MESSAGES.MAX_LENGTH(1000)),
  }),
  SEARCH_REPORTS: yup.object().shape({
    callerId: yup.string().trim().max(100, ERROR_MESSAGES.MAX_LENGTH(100)),
    startDate: yup.string().trim().required(ERROR_MESSAGES.REQUIRED),
    endDate: yup.string().trim().required(ERROR_MESSAGES.REQUIRED),
  }),
  LOGIN_FULL_NAME: yup.object().shape({
    fullName: yup
      .string()
      .trim()
      .required(ERROR_MESSAGES.REQUIRED)
      .max(255, ERROR_MESSAGES.MAX_LENGTH(255)),
  }),
  SEND_REPORT: yup.object().shape({
    reportFormat: yup
      .string()
      .trim()
      .oneOf(
        [REPORT_FILE_FORMAT.CSV, REPORT_FILE_FORMAT.XLSX],
        ERROR_MESSAGES.REQUIRED,
      ),
    sendTo: yup
      .array()
      .of(yup.string().trim().email(ERROR_MESSAGES.EMAIL_NOT_VALID))
      .min(1, ERROR_MESSAGES.REQUIRED),
    subject: yup.string().trim(),
    message: yup.string().trim(),
  }),
};
